module.exports = __webpack_public_path__ + "static/media/luggers-small-01_2x.bf350c39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photos/luggers-small-01_2x.jpg
// module id = 314
// module chunks = 27